module.exports = __webpack_public_path__ + "static/media/display-visual.65edb6c7.jpg";